import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class AddonListQueryFilter extends QueryFilter{
    public organizationId: string;
}
